/* CUSTOM: Fit quiz controller — step navigation, answer tiles, progress state, and redirect into the filtered fit-quiz collection.
   Loaded with defer from snippets/custom-fit-quiz.liquid, which renders .custom-fit-quiz[data-custom-fit-quiz] and passes locale and target URL as data-custom-* attributes. */
(() => {
  const init = () => {
    const quizRoot = document.querySelector('[data-custom-fit-quiz]');

    if (!quizRoot) {
      return;
    }

    const form = quizRoot.querySelector('#custom-fit-form');

    if (!form) {
      return;
    }

    // Liquid-rendered values from the snippet root: data-custom-collection-url, data-custom-locale.
    const baseCollectionUrl = quizRoot.dataset.customCollectionUrl || '';
    const locale = quizRoot.dataset.customLocale || '';
    const steps = [...form.querySelectorAll('.custom-fit-quiz-question')];
    const progress = quizRoot.querySelector('.custom-fit-quiz-progress');
    const progressItems = progress ? [...progress.querySelectorAll('[data-step-index]')] : [];
    const backButtons = [...form.querySelectorAll('.custom-fit-quiz-back')];
    const state = {};

    const typeMap = locale && locale.indexOf('de') === 0
      ? {
          Bikini: [
            'filter.p.product_type=Bikini+Hosen',
            'filter.p.product_type=Bikini+Tops'
          ],
          OnePiece: ['filter.p.product_type=Badeanz%C3%BCge'],
          Mix: []
        }
      : {
          Bikini: [
            'filter.p.product_type=Bikini+Bottoms',
            'filter.p.product_type=Bikini+Tops'
          ],
          OnePiece: ['filter.p.product_type=Swimsuits'],
          Mix: []
        };

    const filterMap = {
      style: {
        Playful: 'filter.p.m.passform.style=gid%3A%2F%2Fshopify%2FMetaobject%2F259801415945',
        Sporty: 'filter.p.m.passform.style=gid%3A%2F%2Fshopify%2FMetaobject%2F259801547017',
        Elegant: 'filter.p.m.passform.style=gid%3A%2F%2Fshopify%2FMetaobject%2F259801710857'
      },
      type: typeMap,
      coverage: {
        Less: 'filter.p.m.passform.coverage=gid%3A%2F%2Fshopify%2FMetaobject%2F259801284873',
        More: 'filter.p.m.passform.coverage=gid%3A%2F%2Fshopify%2FMetaobject%2F259801383177'
      },
      bust: {
        Smaller: 'filter.p.m.passform.oberweite=gid%3A%2F%2Fshopify%2FMetaobject%2F259801219337',
        Medium: null,
        Larger: 'filter.p.m.passform.oberweite=gid%3A%2F%2Fshopify%2FMetaobject%2F259801153801'
      }
    };

    const currentStepIndex = () => (Number.isInteger(state.currentStep) ? state.currentStep : 0);

    const clearError = (container) => {
      const errorElement = container.querySelector('.custom-fit-quiz-error-message');

      if (errorElement) {
        errorElement.style.display = 'none';
      }
    };

    const showError = (container) => {
      const errorElement = container.querySelector('.custom-fit-quiz-error-message');

      if (errorElement) {
        errorElement.style.display = 'block';
      }
    };

    const stepHasSelection = (index) => {
      const section = steps[index];

      return !!(section && section.querySelector('input[type="radio"]:checked'));
    };

    const updateProgressUi = () => {
      const currentIndex = currentStepIndex();

      progressItems.forEach((item, index) => {
        const link = item.querySelector('.custom-fit-quiz-step-link');
        const isCurrent = index === currentIndex;

        item.classList.toggle('is-current', isCurrent);
        item.classList.toggle('is-done', stepHasSelection(index));

        if (link) {
          link.setAttribute('aria-current', isCurrent ? 'step' : 'false');
        }
      });
    };

    const updateBackButtons = () => {
      const currentIndex = currentStepIndex();

      backButtons.forEach((button) => {
        const section = button.closest('.custom-fit-quiz-question');
        button.hidden = !section || Number(section.getAttribute('data-step')) === 0 || section.hidden;
      });

      if (steps[currentIndex]) {
        clearError(steps[currentIndex]);
      }
    };

    const setStepVisible = (index, options) => {
      const settings = options || {};
      const focusHeading = settings.focusHeading !== false;

      steps.forEach((section, stepIndex) => {
        const showSection = stepIndex === index;

        section.hidden = !showSection;

        if (!showSection) {
          clearError(section);
          return;
        }

        const heading = section.querySelector('h2');

        if (heading) {
          heading.setAttribute('tabindex', '-1');

          if (focusHeading) {
            heading.focus();
          }
        }
      });

      state.currentStep = index;
      updateProgressUi();
      updateBackButtons();
    };

    const goToResults = () => {
      const params = new Set();

      if (state.style && filterMap.style[state.style]) {
        params.add(filterMap.style[state.style]);
      }

      if (state.type) {
        (filterMap.type[state.type] || []).forEach((param) => {
          params.add(param);
        });
      }

      if (state.coverage && filterMap.coverage[state.coverage]) {
        params.add(filterMap.coverage[state.coverage]);
      }

      if (state.bust && filterMap.bust[state.bust]) {
        params.add(filterMap.bust[state.bust]);
      }

      const query = Array.from(params).join('&');
      window.location.href = `${baseCollectionUrl}${query ? `?${query}` : ''}`;
    };

    progressItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        const targetIndex = parseInt(item.getAttribute('data-step-index'), 10);
        const currentIndex = currentStepIndex();

        event.preventDefault();

        if (targetIndex === currentIndex) {
          return;
        }

        if (targetIndex < currentIndex) {
          setStepVisible(targetIndex);
          return;
        }

        if (!stepHasSelection(currentIndex)) {
          showError(steps[currentIndex]);
          return;
        }

        setStepVisible(targetIndex);
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const currentIndex = currentStepIndex();

        if (currentIndex > 0) {
          setStepVisible(currentIndex - 1);
        }
      });
    });

    form.addEventListener('change', (event) => {
      const input = event.target;

      if (!input || input.type !== 'radio' || !input.name) {
        return;
      }

      form.querySelectorAll(`input[type="radio"][name="${input.name}"]`).forEach((optionInput) => {
        const tile = optionInput.closest('.custom-fit-quiz-radio-tile');

        if (tile) {
          tile.classList.remove('selected');
        }
      });

      if (input.closest('.custom-fit-quiz-radio-tile')) {
        input.closest('.custom-fit-quiz-radio-tile').classList.add('selected');
      }

      state[input.name] = input.value;
      const section = input.closest('.custom-fit-quiz-question');
      const stepIndex = steps.indexOf(section);

      updateProgressUi();

      if (stepIndex > -1 && stepIndex < steps.length - 1) {
        window.setTimeout(() => {
          setStepVisible(stepIndex + 1);
        }, 120);

        return;
      }

      if (stepIndex === steps.length - 1) {
        window.setTimeout(goToResults, 120);
      }
    });

    form.addEventListener('click', (event) => {
      const tile = event.target.closest('.custom-fit-quiz-radio-tile');

      if (!tile) {
        return;
      }

      const input = tile.querySelector('input[type="radio"]');

      if (!input || state[input.name] !== input.value) {
        return;
      }

      const section = tile.closest('.custom-fit-quiz-question');
      const stepIndex = steps.indexOf(section);

      if (stepIndex > -1 && stepIndex < steps.length - 1) {
        window.setTimeout(() => {
          setStepVisible(stepIndex + 1);
        }, 80);

        return;
      }

      if (stepIndex === steps.length - 1) {
        window.setTimeout(goToResults, 80);
      }
    });

    form.addEventListener('submit', (event) => {
      const currentIndex = currentStepIndex();

      event.preventDefault();

      if (!stepHasSelection(currentIndex)) {
        showError(steps[currentIndex]);
        return;
      }

      goToResults();
    });

    setStepVisible(0, { focusHeading: false });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
